import { createContext } from 'react';

/**
 * Vaut true quand le rendu se trouve DEJA a l'interieur du MainLayout (navbar presente).
 * Permet a une page (ex. PageStatut) de ne pas re-enrober un second MainLayout — ce qui
 * provoquerait une imbrication (double navbar) et un crash.
 */
export const InsideLayoutContext = createContext(false);
